/**
 * Read-only banner + wrapper for panel areas without write access.
 */

import React, { type ReactNode } from 'react';
import { Alert } from 'react-bootstrap';
import { usePanelAccess } from '../../contexts/PanelAccessContext';

export function PanelReadOnlyBanner({
  area,
  message = 'Solo lectura: no tienes permiso para crear o editar en esta sección.',
}: {
  area: string;
  message?: string;
}) {
  const { canWrite, ready, isGodMode } = usePanelAccess();
  if (!ready || isGodMode || canWrite(area)) return null;
  return (
    <Alert variant="secondary" className="mb-3 py-2">
      {message}
    </Alert>
  );
}

/**
 * Hides children when the user cannot write the given area.
 * Use around "Nuevo" / "Editar" / "Eliminar" CTAs.
 */
export function RequirePanelWrite({
  area,
  children,
  fallback = null,
}: {
  area: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { canWrite, ready, isGodMode } = usePanelAccess();
  if (!ready) return null;
  if (isGodMode || canWrite(area)) return <>{children}</>;
  return <>{fallback}</>;
}
